module.exports = __webpack_public_path__ + "img/tip_warning_en.e2226c82.png";